import moment from 'moment';
import { translateActions } from './translate-slice';
import { genderTypes } from '../../enums/genderTypes';
import { fetchStaticJson } from '../../utils/utils';

export const initLang = ({ currentLang, user, userDetails }) => {
    return async (dispatch, getState) => {
        const fromStorage = localStorage.getItem("LANG");
        const lang = currentLang || fromStorage || 'he';
        dispatch(translateActions.initLang({ currentLang: lang, user, userDetails }));

        try {
            if (lang === 'he') {
                await import('moment/locale/he');
                moment.locale('he');
            } else if (lang === 'ar') {
                await import('moment/locale/ar');
                moment.locale('ar');
            }
            else
                moment.locale('en');
        }
        catch (error) {
            console.error('Error loading moment locale:', error);
        }
    }
}

export const initTexts = () => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const genderId = state.auth.userDetails?.genderId;
            const lang = state.translate.lang;

            if (!lang) {
                return;
            }
            const res = await fetchStaticJson(window.config.translationFile.replace('lang', lang));
            if (!res) {
                dispatch(translateActions.initText({ texts: {} }));
                return;
            }
            const hasGenders = Object.keys(res).some(key => Object.values(genderTypes)?.includes(key));
            const isDotted = !!state.auth.userDetails?.grade && window.config?.dottedText?.includes(state.auth.userDetails.grade);
            let myTexts = {};
            if (hasGenders) {
                const genderKey = genderTypes[genderId]; // "male" / "female"
                const allText = res?.all || {};
                const genderText = res?.[genderKey] || {};
                const dottedOverrides = isDotted ? { ...(allText.dotted || {}), ...(genderText.dotted || {}) } : {};
                myTexts = { ...allText, ...genderText, ...dottedOverrides };
            }
            else if (res?.all) {
                const allText = res.all || {};
                const dottedOverrides = isDotted ? (allText.dotted || {}) : {};
                myTexts = { ...allText, ...dottedOverrides };
            } else {
                myTexts = res;
            }

            dispatch(translateActions.initText({ texts: myTexts }));
        } catch (error) {
            console.error('Error in initTexts:', error);
            dispatch(translateActions.initText({ texts: {} }));
        }
    };
};

export const changeLang = (lang) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const { user } = state.auth;
            const storageKey ='LANG';
            localStorage.setItem(storageKey, lang);
            if (lang === 'he') {
                await import('moment/locale/he');
                moment.locale('he');
            }
            else if (lang === 'ar') {
                await import('moment/locale/ar');
                moment.locale('ar');
            }
            else
                moment.locale('en');
            window.location.reload();
        }
        catch {
        }
    }
}